module.exports = {"522725001":"雍阳街道","522725002":"瓮水街道","522725101":"平定营镇","522725103":"中坪镇","522725104":"建中镇","522725105":"永和镇","522725106":"珠藏镇","522725107":"玉山镇","522725108":"天文镇","522725109":"银盏镇","522725110":"猴场镇","522725111":"江界河镇","522725205":"岚关乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522725.json
// module id = 2530
// module chunks = 0